

export const ROLE_ID = {
    Admin: 1,
    Customer: 2,
    Owner: 3,
    Cashier: 4
};
